import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {SwissAppConfigModels} from '../models/swissappconfig-models';
import {TimeSheetModels} from '../models/timesheet-models';
import {HelperService} from './helper.service';
import {UserAuthenticationService} from './user-authentication.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root'
})
export class TimeSheetService {

    private webServiceConfig?: SwissAppConfigModels.WebServiceConfig;

    constructor(private http: HttpClient, private userAuthService: UserAuthenticationService, private helperService: HelperService) {
        this.helperService.getSwissWebServiceConfig$().pipe(
            takeUntilDestroyed(),
            tap((config) => {
                this.webServiceConfig = config;
            })
        ).subscribe();
    }

    getKostenstellen(): Observable<TimeSheetModels.CostCenter[]> {
        if (!this.webServiceConfig) {
            throw new Error();
        }
        return this.http.get<TimeSheetModels.CostCenter[]>(this.webServiceConfig.tishUrl + '/GetAllCostCenter?MandantID=' + this.userAuthService.getCurrentAuthenticatedUser()?.mandatorID, this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo));
    }
}
